export default {
      id: "list-icon-usage",
      viewBox: "0 0 28 28",
      url: __webpack_public_path__ + "ico/gefera/sprite.svg#list-icon",
      toString: function () {
        return this.url;
      }
    }